import React from "react";
import { UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";
import { ManageMultipleFilesModal } from "./ManageMultipleFilesModal";

interface Props {
  trainId: number
  isOpen: boolean
  onClose: () => void
  canEdit: boolean

  files: server.dto.File[]
  onFilesChanged: () => Promise<void>
}

export const ManageTrainPassengerFilesModal = (props: Props) => {
  const uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.Train.UploadFiles,
      window.CoreApi.Train.UploadFiles.absoluteUrl(),
      {
        files,
        trainId: props.trainId
      },
      uploadConfig
    );
  };

  // After removing the last file, the parent might be removed from the DOM
  // In in-page editing scenarios, we need to ensure we call the cancel function
  React.useEffect(() => {
    return () => props.onClose();
  }, []);

  return <ManageMultipleFilesModal
    {...props}
    upload={uploadFiles}
    deleteEndpoint={(id: number) => window.CoreApi.Train.DeleteFile({
      trainFileId: id
    })}
    renameEndpoint={(file: server.dto.File) => window.CoreApi.Train.UpdateFileName({
      trainFileId: file.id,
      fileName: file.name
    })}
  />
}